import React, { PropsWithChildren } from 'react';

const AuthLayout: React.FC<PropsWithChildren> = ({ children }) => {
    return (
        <div className="flex min-h-screen flex-col md:flex-row">
            <div className="flex w-full items-center justify-center bg-white p-6 sm:p-8">
                <div className="w-full max-w-md">
                    {/* Logo container */}
                    <div className="mb-12 flex justify-center">
                        <img
                            src="/static/img/conquerx_logo.png"
                            alt="Logo"
                            className="h-10"
                        />
                    </div>

                    {children}
                </div>
            </div>
        </div>
    );
};

export default AuthLayout;
